module.exports = "/static/assets/fb12dae6a35129a53306397ae0c3b334.gif";